import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ValidationRules } from '$shared/components/address-widget-picker/model/address-widget-picker-validation-rules';
import { AddressWidgetPickerConfigType } from '$shared/components/address-widget-picker/model/address-widget-picker-config-type';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AddressWidgetService {
  public url = '/v1/service-contact-widget-rules';

  constructor(private readonly http: HttpClient) {}

  public getAddressRules(
    config: AddressWidgetPickerConfigType
  ): Observable<ValidationRules> {
    let headers = new HttpHeaders().set(
      'X-Service-Type',
      config.belpostServiceType
    );

    if (config.countryCode) {
      headers = headers.set('X-Country-Code', config.countryCode);
    }

    if (config.isEmailRequired) {
      headers = headers.set(
        'X-SENDER-EMAIL-REQUIRED',
        config.isEmailRequired ? '1' : '0'
      );
    }
    if (config.isPhoneRequired) {
      headers = headers.set(
        'X-SENDER-PHONE-REQUIRED',
        config.isPhoneRequired ? '1' : '0'
      );
    }

    if (config.isRecipientPhoneRequired) {
      headers = headers.set(
        'X-RECIPIENT-PHONE-REQUIRED',
        config.isRecipientPhoneRequired ? '1' : '0'
      );
    }

    if (config.isCashOnDelivery) {
      headers = headers.set(
        'X-CASH-ON-DELIVERY-REQUIRED',
        config.isCashOnDelivery ? '1' : '0'
      );
    }

    if (config.addressType) {
      headers = headers.set('X-ADDRESS-TYPE', config.addressType);
    }

    if (config.holidayKey) {
      headers = headers.set('X-Greeting-Service-Key', config.holidayKey);
    }

    if (config.isSenderIdentified) {
      headers = headers.set(
        'X-Identified-Sender',
        config.isSenderIdentified ? '1' : '0'
      );
    }

    return this.http.get<ValidationRules>(this.url, { headers }).pipe(
      map(({ recipient, sender }) => ({
        recipient: Boolean(recipient) ? recipient : [],
        sender: Boolean(sender) ? sender : [],
      }))
    );
  }
}
